<div class="modal-title p-3">
    <strong>Inactivity</strong>
</div>

<div class="modal-body p-3">
    <p>You're being timed out due to inactivity. Please choose to stay signed in or to logoff. </p>
    <p>Otherwise, you will be logged off automatically</p>

</div>
<div class="modal-footer p-3">
    <button type="button" class="btn btn-primary" (click)="stay()">Stay Logged In</button>
    <button type="button" class="btn btn-secondary" (click)="logout()">Log Off ({{autoCloseTimer}}s)</button>
</div>